import { render, staticRenderFns } from "./PrescriptionItem.vue?vue&type=template&id=357aa7cb&"
import script from "./PrescriptionItem.vue?vue&type=script&lang=js&"
export * from "./PrescriptionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports